import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_14: FaireProductEntity = {
  token: "atc_fs_14",
  type: "product",
  name: "Deodorant Wipes Variety Pack",
  brandName: "Fomin",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/72a0246dfb2c7f5c103865975dd69579da0b926ff012ccfee29299cd3ec17d67.webp",
  priceDollars: 14,
  msrpDollars: 28,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
